/** 
 * Alternative Header  
**/

function handleHoverNotification(dis){
  const elem = dis.querySelector('.alternative-header__notification-close');
  elem.classList.add('active');
}

function handleLeaveNotification(dis){
  const elem = dis.querySelector('.alternative-header__notification-close');
  elem.classList.remove('active');
}

function handleToggleNotification(dis, close) {
  elem = dis.parentElement;
  elem.classList.toggle('active');
  if(close){
    setTimeout(() => {
      elem.style.display = 'none';
    }
    , 300);
  }
}

function openCircularMenu(dis){
  const menuToOpen = document.querySelector('.drawerCircularMenu');
  menuToOpen.style.display = 'block';
  setTimeout(() => {
    menuToOpen.classList.add('active');
  }, 100);
}

function closeCircularMenu(dis){
  const menuToClose = document.querySelector('.drawerCircularMenu');
  menuToClose.classList.remove('active');
  setTimeout(() => {
    menuToClose.style.display = 'none';
  }, 300);
}

const notifications = document.querySelectorAll('.alternative-header__notification-close');
let delay = 3000;

notifications.forEach((notification, index) => {
  setTimeout(() => {
    handleToggleNotification(notification);
  }, delay);
  delay += 200;
});


/**
 * Image with carousel
**/
const carousels = document.querySelectorAll('.image-carousel_general');


//Carousel function
/*
carousels.forEach((carousel, index) => {
  const carouselItems = carousel.querySelectorAll('.image-carousel_carousel__item');
  const carouselToMove = carousel.querySelector('.image-carousel_carousel__items');
  const carouselControlsContainer = carousel.querySelector('.image-carousel_controls');
  let itemsPositions = [];
  let carouselControls = '';
  let actualPosition = 0;
  carouselItems.forEach((item, index) => {
    itemsPositions.push(item.offsetWidth + 10);
    carouselControls += `<div class="image-carousel_control ${index == 0 ? 'active' : ''}" data-bullet="${index}"></div>`;
  });
  carouselControlsContainer.innerHTML = carouselControls;
  function moveCarousel() {
    actualPosition++;
    if (actualPosition >= carouselItems.length) {
      actualPosition = 0;
    }
    let newPosition = 0;
    carouselControlsContainer.querySelectorAll('.image-carousel_control').forEach((control, index) => {
      control.classList.remove('active');
    });
    carouselControlsContainer.querySelector(`[data-bullet="${actualPosition}"]`).classList.add('active');
    for (let i = 0; i < actualPosition; i++) {
      newPosition += itemsPositions[i];
    }
    carouselToMove.style.transform = `translateX(-${newPosition}px)`;
  }
  setInterval(() => {
    moveCarousel();
  }, 5000);
});

*/
//Carousel function
carousels.forEach((carousel, index) => {
  const carouselItems = carousel.querySelectorAll('.image-carousel_carousel__item');
  const carouselControlsContainer = carousel.querySelector('.image-carousel_controls');
  let carouselControls = '';
  let actualPosition = 0;
  carouselItems.forEach((item, index) => {
    item.style.opacity = index == 0 ? '1' : '0';  // Inicializa la opacidad de los elementos
    carouselControls += `<div class="image-carousel_control ${index == 0 ? 'active' : ''}" data-bullet="${index}"></div>`;
  });
  carouselControlsContainer.innerHTML = carouselControls;
  function moveCarousel() {
    carouselItems[actualPosition].style.opacity = '0';  // Oculta el elemento actual
    actualPosition++;
    if (actualPosition >= carouselItems.length) {
      actualPosition = 0;
    }
    carouselItems[actualPosition].style.opacity = '1';  // Muestra el nuevo elemento
    carouselControlsContainer.querySelectorAll('.image-carousel_control').forEach((control, index) => {
      control.classList.remove('active');
    });
    carouselControlsContainer.querySelector(`[data-bullet="${actualPosition}"]`).classList.add('active');
  }
  setInterval(() => {
    moveCarousel();
  }, 1500);
});

//Lanzar solo si el dispositivo tiene más de 1100 de width
if(window.innerWidth < 1100){
  /*
  const littleBlocksCarousel = document.querySelectorAll('.image-carousel_carousel__content');
  littleBlocksCarousel.forEach((littleBlock, index) => {
    //vamos a hacer que sea un carrusel automático que se mueva con un transform. El transform se tiene que calcular en base al ancho de los elementos. Sin controles
    const littleBlocks = littleBlock.querySelectorAll('.image-carousel_carousel__text');
    const carouselToMovel = littleBlock.querySelector('.image-carousel_carousel__content__carousel');
    const littleBlocksSize = [];
    let actualPosition = 0;
    let actualTransform = 0;
    let totalMoves = littleBlocks.length;
    let littleBlocksControls = '';
    littleBlocks.forEach((block, index) => {
      littleBlocksSize.push(block.offsetWidth);
    })
    function moveLittleBlocks() {
      actualPosition++;
      if (actualPosition >= totalMoves) {
        actualPosition = 0;
        actualTransform = 0;
      }
      else{
        actualTransform += littleBlocksSize[actualPosition - 1];
      }
      carouselToMovel.style.transform = `translateX(-${actualTransform}px)`;
    }
    setInterval(() => {
      moveLittleBlocks();
    }, 5000);
  });
  */
  /*
  const finalBlocksCarousel = document.querySelectorAll('.adaptative-containers__blocks');
  finalBlocksCarousel.forEach((finalBlock, index) => {
    //vamos a hacer que sea un carrusel automático que se mueva con un transform. El transform se tiene que calcular en base al ancho de los elementos. Sin controles
    const finalBlocks = finalBlock.querySelectorAll('.adaptative-containers__block');
    const carouselToMovel = finalBlock.querySelector('.adaptative-containers__blocks_carousel');
    const finalBlocksSize = [];
    let actualPosition = 0;
    let actualTransform = 0;
    let totalMoves = finalBlocks.length;
    let finalBlocksControls = '';
    finalBlocks.forEach((block, index) => {
      finalBlocksSize.push(block.offsetWidth);
    })
    function moveFinalBlocks() {
      actualPosition++;
      if (actualPosition >= totalMoves) {
        actualPosition = 0;
        actualTransform = 0;
      }
      else{
        actualTransform += finalBlocksSize[actualPosition - 1] + 9;
      }
      carouselToMovel.style.transform = `translateX(-${actualTransform}px)`;
    }
    setInterval(() => {
      moveFinalBlocks();
    }, 3500);
  });
  */
}



//Function to show white circles when the carousel is in the viewport

const circles = document.querySelectorAll('.image-carousel__circles span');
const targetCircles = document.querySelector('.image-carousel_general')
const optionsCircles = {
  root: null,
  rootMargin: '0px',
  threshold: 0.8
};
function handleIntersectionCircles(entries, observerCircles){
  entries.forEach(entry => {
    if(entry.isIntersecting){
      circles.forEach((circle, index) => {
        setTimeout(() => {
          circle.classList.add('active');
        }, index * 300);
      });
    }
    else{
      circles.forEach((circle, index) => {
        circle.classList.remove('active');
      });
    }
  });
}

const observerCircles = new IntersectionObserver(handleIntersectionCircles, optionsCircles);

setTimeout(() => {
  observerCircles.observe(targetCircles);
}, 500);


/**
 * Text with images hover
**/

const logoItems = document.querySelectorAll('.text-images-hover__logo-item');
const heightWindow = window.innerHeight;
logoItems.forEach((logo, index) => {
  const optionsLogos = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };
  function handleScroll() {
    let scrollActual = window.scrollY;
    let logoPosition = logo.getBoundingClientRect();
    let logoPositionScroll = logoPosition.top + window.scrollY;
    if(logoPositionScroll - ((heightWindow / 3) * 2.85) + index * 50 < scrollActual){
      logo.classList.add('active');
    }
    else{
      logo.classList.remove('active');
    }
  }
  function handleIntersectionLogos(entries, observerLogos){
    entries.forEach(entry => {
      if(entry.isIntersecting){
        window.addEventListener('scroll', handleScroll);
      }
      else{
        window.removeEventListener('scroll', handleScroll);
        entry.target.classList.remove('active');
      }
    });
  }
  
  const observerLogos = new IntersectionObserver(handleIntersectionLogos, optionsLogos);
  observerLogos.observe(logo);
});

const logoItems_header = document.querySelectorAll('.text-images-hover__logo-item-header');
logoItems_header.forEach((logo, index) => {
  const optionsLogos = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };
  function handleScroll() {
    let scrollActual = window.scrollY;
    let logoPosition = logo.getBoundingClientRect();
    let logoPositionScroll = logoPosition.top + window.scrollY;
    if(logoPositionScroll - ((heightWindow / 3 * 2) * 1) + index * 65 < scrollActual){
      logo.classList.add('active');
    }
    else{
      logo.classList.remove('active');
    }
  }
  function handleIntersectionLogos(entries, observerLogos){
    entries.forEach(entry => {
      if(entry.isIntersecting){
        window.addEventListener('scroll', handleScroll);
      }
      else{
        window.removeEventListener('scroll', handleScroll);
        entry.target.classList.remove('active');
      }
    });
  }
  
  const observerLogos = new IntersectionObserver(handleIntersectionLogos, optionsLogos);
  observerLogos.observe(logo);
});


/** 
 * Custom Modal
 * **/
if(document.querySelector('.custom-modal_general')){
  const mainElement = document.querySelector('main');
  const modals = document.querySelectorAll('.custom-modal_general');
  mainElement.insertAdjacentHTML('afterbegin', '<div id="overlayCustomModal"></div>');
  modals.forEach((modal, index) => {
    console.log(modal)
    mainElement.prepend(modal);
  });
  
  function handleOpenModal(dis){
    const modalIdentifier = dis.getAttribute('data-modal');
    const overlay = document.querySelector('#overlayCustomModal');
    const modal = document.querySelector(`#${modalIdentifier}`);
    overlay.style.display = 'block';
    setTimeout(() => {
      overlay.classList.add('active');
    }, 100);
    setTimeout(() => {
      modal.style.display = 'block';
      setTimeout(() => {
        modal.classList.add('active');
      }, 100);
    }, 300);
  }

  function handleCloseModal(){
    const overlay = document.querySelector('#overlayCustomModal');
    const modals = document.querySelectorAll('.custom-modal_general');
    modals.forEach((modal) => {
      modal.classList.remove('active');
    });
    setTimeout(() => {
      overlay.classList.remove('active');
      setTimeout(() => {
        overlay.style.display = 'none';
        modals.forEach((modal) => {
          modal.style.display = 'none';
        });
      }, 300);
    }, 300);
    document.body.style.overflow = 'auto';  // Desbloquea el desplazamiento
  }
}

